import React, { useState, useEffect } from "react";
import "./AddTextModal.css";
import RichTextEditor from "./helpers/RichTextEditor";

const AddTextModal = ({
  show,
  onClose,
  onSave,
  initialContent,
  index,
  isNewMaterial = false,
}) => {
  const [textContent, setTextContent] = useState("");

  useEffect(() => {
    if (initialContent) {
      setTextContent(initialContent);
    }
  }, [initialContent]);

  const handleSave = () => {
    onSave(index, textContent);
  };

  const handleCancel = () => {
    if (isNewMaterial) {
      // If it's a new material, delete it regardless of content
      onClose(true);
    } else {
      // For existing materials, just close the modal
      onClose(false);
    }
  };

  if (!show) {
    return null;
  }

  return (
    <div className="add-text-modal-content">
      <div className="text-content-wrapper">
        <RichTextEditor
          value={textContent}
          onChange={setTextContent}
          onSave={handleSave}
          onCancel={handleCancel}
          placeholder="Start typing your text..."
        />
      </div>
    </div>
  );
};

export default AddTextModal;
